//
// Module for the Correspondence index view
//
rs.module("framework/content/correspondence/correspondence",

    ["controls/data/grid" ],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, packetKey, previewDocumentKey, refreshTimer, lrsGridApi, backendUrls) {

            // Unpack js selectors
            var filter = $.js(jsSelectors.filter);
            var includeCancelledCheckbox = filter.js(jsSelectors.includeCancelledCheckbox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Handle include cancelled grid filter change event.
            includeCancelledCheckbox.change(includeCheckboxChangedEvent);

            // If refreshTimer is set, reload the grid in one second.
            if (refreshTimer) {
                _setupTimer();
            }

            // Setup a 1-second timer for delayed Correspondence grid refresh
            function _setupTimer() {
                setTimeout(refreshcorrespondenceGrid, 1000);
            }

            // Handle the include cancelled checkbox change event.
            function includeCheckboxChangedEvent() {
                loadingSpinner.show();
                refreshcorrespondenceGrid();
            }

            // Refresh the Correspondence grid
            function refreshcorrespondenceGrid() {
                gridModule.update(
                    backendUrls.updateGrid,

                    { includeCancelledStatus: includeCancelledCheckbox.is(':checked'), packetKey: packetKey },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) { }
                ).always(function () {
                    loadingSpinner.hide();
                });
            }

            // If the user is generating a preview of a document, download it now.
            if (previewDocumentKey) {
                $.ajax({
                    url: backendUrls.downloadPreview,
                    data: {
                        documentKey: previewDocumentKey
                    },
                    success: function (data) {
                        // Queue up a file download.  We need to do this rather than directly call window.location.href because that can terminate 
                        // javascript running on the page
                        $(document).ready(function () {
                            window.location.href = data.url;
                        });
                    }
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);